import React, { useEffect, useState } from "react";
import { TfiClose } from "react-icons/tfi";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import Cookies from "js-cookie";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [loading, setLoading] = useState(true);

  const [navLinks, setNavLinks] = useState([
    { text: "Home", url: "/" },
    {
      text: "Services",
      url: "/services",
      submenu: true,
      dropdown: [
        {
          name: "Management Systems",
          link: "/iso-lead-auditor-training#management-systems",
        },
        {
          name: "IT & Security",
          link: "/iso-lead-auditor-training#it-security",
        },
        {
          name: "Laboratory & Inspection",
          link: "/iso-lead-auditor-training#laboratory-inspection",
        },
        {
          name: "Food Safety",
          link: "/iso-lead-auditor-training#food-safety",
        },
        {
          name: "Sustainability",
          link: "/iso-lead-auditor-training#sustainability",
        },
        {
          name: "Consulting & Audit",
          link: "/iso-lead-auditor-training#consulting-audit",
        },
      ],
    },
    {
      text: "About Us",
      url: "/about",
      submenu: true,
      dropdown: [
        { name: "Our Team", link: "/team" },
        { name: "Clientele", link: "/clientele" },
        { name: "Certifications", link: "/Certifications" },
        { name: "Jobs", link: "/jobs" },
        { name: "Company Introduction", link: "/company-introduction" },
        { name: "Mission", link: "/mission" },
        { name: "Vision", link: "/vision" },
        { name: "Our Diversified Clientele", link: "/diversified-clientele" },
      ],
    },
    { text: "ToolKits", url: "/toolkits" },
    { text: "Sustainability", url: "/sustainability" },
    {
      text: "Training",
      url: "/training",
      submenu: true,
      dropdown: [
        { name: "HighField Trainings ", link: "/highfield-training" },
        { name: "HACCP Level 2 / 3 / 4", link: "/haccp-training" },
        { name: "PECB", link: "/pecb-training" },
        {
          name: "ISO Lead Auditor Trainings",
          link: "/iso-lead-auditor-training",
        },
        { name: "Corporate Trainings", link: "/corporate-training" },
      ],
    },
    {
      text: "Resources",
      url: "/resources",
      submenu: true,
      dropdown: [
        { name: "Blog ", link: "/blog" },
        { name: "Downloads", link: "/downloads" },
        { name: "FAQs", link: "/faq" },
      ],
    },
    { text: "Fsc Certifications", url: "/fsc-certification" },
    // { text: "Blogs", url: "/blog" },
    { text: "Tracking", url: "/tracking" },

    // { text: "Contact Us", url: "/contact" },
  ]);

  const Logo = `${process.env.PUBLIC_URL}/assets/Logo.webp`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const serviceResponse = await fetch(
          "https://api.mbasolutions.co/api/categories/get",
        );
        const serviceData = await serviceResponse.json();

        const newServices = [
          { name: "ISO Certifications", link: "/iso-certifications" },
          { name: "FSC COC Certifications", link: "/fsc-certification" },
        ];

        const updated = [...serviceData, ...newServices];

        const filteredServices = updated.map((service) => ({
          name: service.name,
          link: `/service/${service._id}`,
        }));

        setNavLinks((prev) =>
          prev.map((link) =>
            link.text === "Our Services"
              ? { ...link, dropdown: filteredServices }
              : link,
          ),
        );

        setLoading(false);
      } catch (error) {
        console.error("Error fetching service data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleNav = () => setNav(!nav);

  const handleLinkClick = (link) => {
    if (link?.includes("/service/")) {
      const id = link.split("/").pop();
      Cookies.set("clickedServiceId", id, { expires: 1 / 24 });
    }
    setNav(false);
  };

  // ====== Simple fade + slide for dropdown ======
  const dropdownVariant = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.25 } },
  };

  return (
    <div className="poppins sticky top-0 z-[1000] bg-white h-24 shadow-sm">
      <div className="h-24 flex justify-between items-center md:px-7 p-4 text-sm">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/" onClick={() => handleLinkClick("/")}>
            <img src={Logo} alt="MBA SOLUTIONS" className="h-16" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex items-center space-x-6 font-medium text-gray-800">
          {navLinks.map((li, index) => (
            <div
              key={index}
              className="relative"
              onMouseEnter={() => setActiveDropdown(index)}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <Link
                to={li.url}
                className="flex items-center gap-1 hover:text-[var(--bg-primary)] transition-colors"
              >
                {li.text} {li.submenu && <BsChevronDown />}
              </Link>

              {li.submenu && (
                <motion.div
                  initial="hidden"
                  animate={activeDropdown === index ? "visible" : "hidden"}
                  variants={dropdownVariant}
                  className={`absolute top-8 left-0 w-48 bg-white rounded-lg shadow-md border border-gray-100 transition-all ${
                    activeDropdown === index
                      ? "opacity-100 visible"
                      : "opacity-0 invisible"
                  }`}
                >
                  <div className="p-3 flex flex-col space-y-2 max-h-60 overflow-y-auto">
                    {loading ? (
                      <p className="text-sm text-gray-400">Loading...</p>
                    ) : (
                      li.dropdown.map((item, i) => (
                        <Link
                          key={i}
                          to={item.link}
                          onClick={() => handleLinkClick(item.link)}
                          className="text-gray-700 hover:text-[var(--bg-primary)] text-sm transition-all"
                        >
                          {item.name}
                        </Link>
                      ))
                    )}
                  </div>
                </motion.div>
              )}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Link to="/contact">
            <button className="px-6 py-2.5 rounded-full bg-[var(--bg-primary)] text-white font-medium shadow-lg relative overflow-hidden group hidden lg:block">
              <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity"></span>
              <span className="relative z-10">Contact Us</span>
            </button>
          </Link>
        </motion.div>

        {/* Mobile Menu Toggle */}
        <div className="lg:hidden">
          <button onClick={handleNav}>
            <FaBars size={22} className="text-gray-700" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {nav && (
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fixed top-0 right-0 w-80 h-screen bg-white shadow-2xl z-[2000] p-6 overflow-y-auto"
          >
            <div className="flex justify-end mb-6">
              <TfiClose
                size={22}
                onClick={handleNav}
                className="cursor-pointer"
              />
            </div>

            <ul className="space-y-4">
              {navLinks.map((li, index) => (
                <div key={index}>
                  <div
                    className="flex justify-between items-center text-gray-800 font-medium cursor-pointer"
                    onClick={() =>
                      setActiveSubmenu(activeSubmenu === index ? null : index)
                    }
                  >
                    <Link to={li.url} onClick={() => handleLinkClick(li.url)}>
                      {li.text}
                    </Link>
                    {li.submenu && (
                      <BsChevronUp
                        className={`transition-transform ${
                          activeSubmenu === index ? "rotate-180" : ""
                        }`}
                      />
                    )}
                  </div>

                  {li.submenu && activeSubmenu === index && (
                    <div className="ml-4 mt-2 space-y-2">
                      {li.dropdown.map((sub, i) => (
                        <Link
                          key={i}
                          to={sub.link}
                          onClick={() => handleLinkClick(sub.link)}
                          className="block text-sm text-gray-600 hover:text-[var(--bg-primary)]"
                        >
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* Mobile CTA */}
              <Link to="/contact" onClick={handleNav}>
                <button className="mt-6 w-full py-3 rounded-full bg-[var(--bg-primary)] text-white font-medium shadow-lg">
                  Contact Us
                </button>
              </Link>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navbar;
